import { Row, Typography } from 'antd';
import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';

import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { useTranslation } from 'react-i18next';
import { DocTypes, InvcVat } from '../../../../services/ML/docTypes';
import { extractDoc } from '../../../../services/ML/DataExtraction/extractDoc';
import { useAppDispatch } from '../../../../store';
import { ocrItemSelected,
  OcrItem,
  ocrItemRemoved,
  ocrItemUpdated } from '../../../../store/impOcr';
import { RowMd } from '../../../../styles';
import { formatDate } from '../../../../utils/helpers/date';
import EvidCard from '../EvidCard';
import { EvidCardItem } from '../EvidCardItem';

const { Text } = Typography;

const InvcVatEvidCard = ({
  ocrItem,
  index,
  onMerge,
  isSelected,
  setSelected,
  selectedItems
}:{
  ocrItem: OcrItem
  index: number,
  isSelected:boolean
  setSelected:(selectedItems: number[]) =>void
  selectedItems: number[],
  onMerge: (clickedIndex: number) => void
}) => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const {
    correctedDocResults,
    pages,
    correctedDocType,
    doc,
    docType
  } = ocrItem;

  if (!_.has(correctedDocResults, 'partialSum')) return null;

  const results = correctedDocResults as InvcVat;

  const {
    dueDate,
    partialSum,
    createDate,
    accountingDoc,
  } = results;

  const onDelete = () => {
    dispatch(ocrItemRemoved(index));
  };

  const onEdit = () => {
    dispatch(ocrItemSelected(index));
  };

  const onDocTypeChange = (dt: DocTypes) => {
    const extractedData = extractDoc(doc, dt);
    dispatch(ocrItemUpdated({
      ocrItem:{
        ...ocrItem,
        correctedDocType: dt,
        extractedData,
        docResults: extractedData,
        correctedDocResults: extractedData,
      },
      index
    }));
  };

  const onMergeClick = () => {
    onMerge(index);
  };

  const onSelect = (e: CheckboxChangeEvent) => {
    if ( e.target.checked && !isSelected) {
      setSelected([
        ...selectedItems,
        index
      ]);
    }
    if (!e.target.checked && isSelected) {
      const cloned = _.cloneDeep(selectedItems).filter(v =>
        v !== index);
      setSelected(cloned);
    }
  };

  return (
    <EvidCard
      {...{
        image: pages[0].image ?? '',
        onDelete,
        onMerge:onMergeClick,
        onEdit,
        pages:pages.length,
        subtitle:createDate ? `${t('InvcVatEvidCard.dated')} ${createDate}` : '',
        title: t('InvcVatEvidCard.invoice'),
        docType: correctedDocType,
        onDocTypeChange,
        onSelect,
        checked:isSelected,
        mergeDisabled: selectedItems.length === 0 || isSelected,
        // TODO: change type
        correctedDocType: docType
      }}
    >
      <Row justify="space-between">
        <EvidCardItem
          title={t('InvcVatEvidCard.sum')}
          value={partialSum ? `${partialSum.toFixed(2)} zł` : '0'}
        />
        <EvidCardItem
          title={t('InvcVatEvidCard.term')}
          value={dueDate ? formatDate(dueDate) : t('NoData')}
        />
      </Row>
      <RowMd>
        <Text type='secondary'>{t('InvcVatEvidCard.number')}</Text>
        <TextStyled strong>{accountingDoc ?? t('NoData')}</TextStyled>
      </RowMd>
    </EvidCard>
  );
};

export default InvcVatEvidCard;

export const createFVTitle = ({ accountingDoc, createDate }: InvcVat) => {
  const FV = 'Faktura VAT';
  if (accountingDoc) return `${FV} nr ${accountingDoc}`;
  if (createDate) return `${FV} z dnia ${createDate}`;
  return FV;
};

const TextStyled  = styled(Text)`
  padding-left: 12px;
  font-size: 500;
`;